import { metricasRespostaSchema } from '@varga/shared';
import { api } from '../lib/http';

export type PeriodoMetricas = 'mes' | '30d' | 'campanha';

function intervalo(p: PeriodoMetricas): string {
  const agora = new Date();
  if (p === 'campanha') return '';
  const de =
    p === 'mes'
      ? new Date(agora.getFullYear(), agora.getMonth(), 1)
      : new Date(agora.getTime() - 30 * 86_400_000);
  return `?de=${de.toISOString()}&ate=${agora.toISOString()}`;
}

/** `GET /v1/metricas?de=&ate=` — agregações do dashboard (toda soma é no banco). */
export function obterMetricas(periodo: PeriodoMetricas) {
  return api(metricasRespostaSchema, `/v1/metricas${intervalo(periodo)}`);
}
